import {
  FacebookIcon,
  InstagramIcon,
  PinterestIcon,
  QuoraIcon,
  TikTokIcon,
  TwitchIcon,
  TwitterXIcon,
  YoutubeIcon,
} from "@ms/gatsby-theme";

import {
  LegalLinkInterface,
  SiteLinkInterface,
  SocialLinkInterface,
} from "@ms/gatsby-site/src/types/footer";

import {
  BLOG_URL,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  PINTEREST_URL,
  PRESS_URL,
  QUORA_URL,
  TIKTOK_URL,
  TWITCH_URL,
  TWITTER_URL,
  YOUTUBE_URL,
} from "./social";

export const siteLinks: SiteLinkInterface[] = [
  {
    title: "About Us",
    to: "/pages/about",
  },
  {
    title: "FAQ",
    to: "/pages/help",
  },
  {
    title: "Blog",
    href: BLOG_URL,
  },
  {
    title: "Manage Orders",
    to: "/account/orders",
  },
  {
    title: "Military",
    to: "/pages/military-discounts",
  },
  {
    title: "First Responders",
    to: "/pages/first-responder-discounts",
  },
  {
    title: "Healthcare Workers",
    to: "/pages/medical-discounts",
  },
  {
    title: "Press",
    href: PRESS_URL,
  },
  {
    title: "CA Notice at Collection ",
    to: "/pages/privacy-policy#section-8",
  },
  {
    title: "CA Do Not Sell or Share My Personal Information",
    to: "/pages/do-not-sell-or-share",
  },
  {
    title: "CA Limit Use of Sensitive Personal Information",
    to: "/pages/limit-the-use-or-disclosure",
  },
  {
    title: "Careers",
    to: "/pages/careers",
  },
  {
    title: "CA Supply Chains Act",
    to: "/pages/ca-supply-chain-act-statement",
  },
  {
    title: "Patents",
    to: "/pages/patent",
  },
  {
    title: "Waterproof Disclaimer",
    to: "/pages/waterproof",
  },
  {
    title: "Contact Us",
    to: "/pages/contact",
  },
  {
    title: "Accessibility Statement",
    to: "/pages/accessibility-statement",
  },
];

export const legalLinks: LegalLinkInterface[] = [
  {
    title: "Warranty & Return",
    to: "/pages/product-offer-warranty-return",
  },
  {
    title: "Terms of Use and Sale",
    to: "/pages/terms-of-use-sale",
  },
  {
    title: "Privacy Policy",
    to: "/pages/privacy-policy",
  },
  {
    title: "Cookie Policy",
    to: "/pages/cookie-policy",
  },
];

export const socialLinks: SocialLinkInterface[] = [
  {
    title: "facebook",
    href: FACEBOOK_URL,
    Icon: FacebookIcon,
  },
  {
    title: "instagram",
    href: INSTAGRAM_URL,
    Icon: InstagramIcon,
  },
  {
    title: "twitter",
    href: TWITTER_URL,
    Icon: TwitterXIcon,
  },
  {
    title: "youtube",
    href: YOUTUBE_URL,
    Icon: YoutubeIcon,
  },
  {
    title: "pinterest",
    href: PINTEREST_URL,
    Icon: PinterestIcon,
  },
  {
    title: "tiktok",
    href: TIKTOK_URL,
    Icon: TikTokIcon,
  },
  {
    title: "quora",
    href: QUORA_URL,
    Icon: QuoraIcon,
  },
  {
    title: "twitch",
    href: TWITCH_URL,
    Icon: TwitchIcon,
  },
];
